export default {"src":"/_next/static/media/ellipse.f96deaee.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};